import { IconProps } from './types'

export const PendingDeliveryIcon = ({ size = 80, color = '#C4C8CD', id, ...props }: IconProps) => (
  <svg id={id} style={{ width: size, height: size * 0.9, flexShrink: 0 }} viewBox='0 0 100 90' fill='none' {...props}>
    {/* Speech bubble */}
    <rect x='68' y='8' width='24' height='16' rx='4' fill='#9CA3AF' />
    <polygon points='72,24 76,24 70,30' fill='#9CA3AF' />
    <circle cx='74' cy='16' r='2' fill='white' />
    <circle cx='80' cy='16' r='2' fill='white' />
    <circle cx='86' cy='16' r='2' fill='white' />

    {/* Paper coming out */}
    <rect x='32' y='18' width='36' height='32' rx='2' fill='#F3F4F6' stroke='#E5E7EB' strokeWidth='1' />
    <line x1='38' y1='28' x2='62' y2='28' stroke='#D1D5DB' strokeWidth='2' strokeLinecap='round' />
    <line x1='38' y1='34' x2='58' y2='34' stroke='#D1D5DB' strokeWidth='2' strokeLinecap='round' />
    <line x1='38' y1='40' x2='54' y2='40' stroke='#D1D5DB' strokeWidth='2' strokeLinecap='round' />

    {/* Printer body - top part */}
    <rect x='22' y='42' width='56' height='18' rx='3' fill={color} />

    {/* Paper slot */}
    <rect x='30' y='44' width='40' height='4' rx='1' fill='#9CA3AF' />

    {/* Printer body - bottom part */}
    <rect x='18' y='56' width='64' height='24' rx='4' fill={color} />

    {/* Paper tray */}
    <rect x='26' y='64' width='48' height='8' rx='2' fill='#F3F4F6' stroke='#E5E7EB' strokeWidth='1' />
  </svg>
)
